import { MutableRefObject, useRef } from 'react';

import { FormsServiceTypes } from '../../services/FormsServices/APIService';
import { FormsService } from '../../services/FormsServices/APIService/index.api';
import { networkCallWithApisauceWithHeaders } from '../../utils/AuthAPIUtils';

import { useFormsRefreshAuthTokens } from '../useFormsRefreshToken';

const useFormsService = () => {
  const { refreshTokenApi, getFormsAccessToken, getFormsRefreshToken } =
    useFormsRefreshAuthTokens();

  const FormsServiceAPIRef: MutableRefObject<FormsServiceTypes | null> =
    useRef(null);

  if (FormsServiceAPIRef.current === null) {
    FormsServiceAPIRef.current = new FormsService(
      networkCallWithApisauceWithHeaders({
        refreshAuthTokensAPI: refreshTokenApi,
        getAccessToken: getFormsAccessToken,
        getRefreshToken: getFormsRefreshToken
      })
    );
  }

  return {
    formsServiceAPI: FormsServiceAPIRef.current
  };
};

export { useFormsService };
